export default function PlaybookView({ data }) {
  if (!data) return null;
  const sections = [
    ["Positioning", data.playbook.positioning, "var(--amber)"],
    ["Include a contact only if", data.playbook.include_only_if, "var(--emerald)"],
    ["Exclude if", data.playbook.exclude_if, "#FB7185"],
    ["Timing", data.playbook.timing, "var(--cyan)"],
    ["Edge cases to watch", data.playbook.edge_cases, "#A855F7"],
  ];
  return (
    <div className="grid lg:grid-cols-2 gap-5" data-testid="playbook-view">
      {sections.map(([title, items, color]) => (
        <section key={title} className="card p-5" style={{ borderTop: `2px solid ${color}` }}>
          <h3 className="text-base font-extrabold mb-3">{title}</h3>
          <ul className="space-y-2">
            {items.map((it, i) => <li key={i} className="text-sm leading-relaxed flex gap-2" style={{ color: "var(--text-2)" }}><span style={{ color }}>—</span>{it}</li>)}
          </ul>
        </section>
      ))}
      <section className="card p-5 lg:col-span-2" style={{ borderTop: "2px solid #64748B" }}>
        <h3 className="text-base font-extrabold mb-1">Excluded / watch-list</h3>
        <p className="text-xs mb-3" style={{ color: "var(--muted)" }}>Deliberately not on the target list — and what to do instead.</p>
        <ul className="grid md:grid-cols-2 gap-2" data-testid="excluded-list">
          {data.excluded.map((e) => (
            <li key={e.name} className="p-3 rounded-xl text-sm" style={{ background: "var(--surface-2)" }}>
              <div className="font-semibold">{e.name}</div>
              <div className="text-xs mt-1 leading-relaxed" style={{ color: "var(--text-2)" }}>{e.reason}</div>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
